// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import MainPage from './components/MainPage'
import VueRouter from 'vue-router'
import frog from './plugins/frog'
import apiService from './services/api'
import Utils from './utils/Utils'

// const query = queryUtil.parse()
// if (query && query.keyfrom === '360') {
//   const instance = new Frog({ productId: 131 })
//   instance.add('/event/estimate/enter-360')
// }

Vue.use(VueRouter)

Vue.config.productionTip = false

const render = () => {
  /* eslint-disable no-new */
  /* eslint-disable-next-line no-undef */
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    components: { App },
    router: new VueRouter({
      routes: [
        { path: '/:status(\\d+)', name: 'main', component: MainPage },
        { path: '*', redirect: '/1' }
      ]
    }),
    template: '<App/>'
  })
}

if (Utils.isYuanSouTi()) {
  apiService.getSolarUser().end((e, res) => {
    window.ytkUserId = res.body.ytkUserId
    Vue.use(frog, {
      fields: {
        userId: res.body.ytkUserId,
        solarUserId: res.body.userId,
        productId: 241
      }
    })
    render()
  })
} else {
  apiService.getUser().then((res) => {
    window.ytkUserId = res.body.id
    Vue.use(frog, {
      fields: {
        userId: res.body.id,
        productId: 241
      }
    })
    render()
  }).catch(() => {
    Vue.use(frog, {
      fields: {
        productId: 241
      }
    })
    render()
  })
}



// WEBPACK FOOTER //
// ./src/main.js